module.exports = __webpack_public_path__ + "static/media/Btn_Send.9e027c67.png";